import React from 'react';
import { Instagram, Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';

interface SocialLinksProps {
  className?: string;
  iconSize?: number;
}

const SocialLinks: React.FC<SocialLinksProps> = ({ className = "flex space-x-4", iconSize = 20 }) => {
  const socials = [
    { name: 'Instagram', icon: Instagram, url: 'https://www.instagram.com/unifigiguatemi?igsh=cjFwc3N2ejFlZTBr' },
  ];

  return (
    <div className={className}>
      {socials.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className="w-10 h-10 bg-white border border-slate-100 rounded-xl flex items-center justify-center text-slate-600 hover:bg-primary hover:text-white hover:border-primary transition-all shadow-sm active:scale-90"
          title={social.name}
        >
          <social.icon size={iconSize} />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
